import React from 'react';

/**
 * DoubleConfirmButton
 *
 * Use:
 * when a button requires a second click
 * to fire off the passed in onSecondClick handler
 */
export default React.createClass({
  displayName: 'DoubleConfirmButton',

  propTypes: {
    onSecondClick: React.PropTypes.func,
    onFirstClick: React.PropTypes.func,
    beforeIcon: React.PropTypes.object,
    afterIcon: React.PropTypes.object,
    text: React.PropTypes.string,
    confirmText: React.PropTypes.string,
    classes: React.PropTypes.string,
    confirmClass: React.PropTypes.string,
    disable: React.PropTypes.bool,
    resetClickState: React.PropTypes.bool,
  },

  getDefaultProps() {
    return {
      beforeIcon: null,
      afterIcon: null,
      text: '',
      confirmText: '',
      classes: '',
      confirmClass: '',
      disable: false,
      resetClickState: false,
    };
  },

  getInitialState() {
    return {
      hasClicked: false,
    };
  },

  render() {
    let {
        beforeIcon,
        afterIcon,
        text,
        confirmText,
        classes,
        confirmClass,
        onSecondClick,
        onFirstClick,
        disable,
        resetClickState,
      } = this.props,
      { hasClicked } = this.state;

    if (resetClickState) {
      hasClicked = false;
    }

    let btnClasses =
      hasClicked === true ? classes + ' ' + confirmClass : classes;

    return (
      <button
        type="button"
        disabled={disable}
        className={btnClasses}
        onClick={() => {
          if (hasClicked) {
            onSecondClick();
            this.setState({ hasClicked: false });
          } else {
            onFirstClick();
            this.setState({ hasClicked: true });
          }
        }}
      >
        {beforeIcon}
        {hasClicked ? confirmText : text}
        {afterIcon}
      </button>
    );
  },
});
